/**
 * ParentTabBar — React Navigation `tabBar` that renders the DS `<BottomTab>`.
 * Global parent tab navigation lives here only — Screens must not re-implement the bar.
 */
import React from "react"
import type { BottomTabBarProps } from "@react-navigation/bottom-tabs"

import { BottomTab, TABS_BY_TYPE } from "../../../../../design-system"
import { routeNameToTabKey, tabKeyToRouteName } from "./parentRoutes"

/**
 * La place que la barre prend en bas d'une racine d'onglet : ce qu'un accusé doit lui laisser
 * pour ne pas se poser dessus (`<Snackbar bottomOffset>`).
 */
export const PARENT_TAB_BAR_HEIGHT = 80

export function ParentTabBar(props: BottomTabBarProps) {
    const { state, navigation } = props
    const routeName = state.routes[state.index]?.name ?? "parent-home"
    const activeKey = routeNameToTabKey(routeName)

    // Hide the bar on destinations that opted out (e.g. parent-subscription portal).
    const focusedOptions = props.descriptors[state.routes[state.index]?.key]?.options
    const tabBarStyle = focusedOptions?.tabBarStyle as { display?: string } | undefined
    if (tabBarStyle?.display === "none") {
        return null
    }

    return (
        <BottomTab
            tabs={TABS_BY_TYPE.parent}
            activeKey={activeKey}
            onTabChange={(key) => {
                const route = tabKeyToRouteName(key)
                // Guard against a tab the navigator doesn't actually register (the parent
                // screen list is built per-user) — navigating to an unknown name throws.
                if (route && state.routeNames.includes(route)) navigation.navigate(route)
            }}
        />
    )
}
